import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e13190d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nongfu-button-wrap" }

import { Button } from 'vant'
import { confirmTechnicalSupport } from '@/apis/malfunction-repair'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { showConfirmModal, showToastLoading, showToastSuccess } from '@/utils/tools'
import { withDefaults, computed, CSSProperties } from 'vue'
import { commonErrorHandle } from '@/utils/error-handle'


export default /*#__PURE__*/_defineComponent({
  __name: 'analysis-confirm-button',
  props: {
    from: { default: 'service-detail' },
    showMarginLeft: { type: Boolean, default: false },
    guid: { default: '' }
  },
  emits: ['update'],
  setup(__props: any, { emit: emits }) {

const props = __props as { from: string, showMarginLeft: boolean, guid: string };

const { removeServiceOrderKeepAlive } = useMalfunctionRepairStore()



const buttonStyle = computed(() => {
  const result: CSSProperties = {}
  const isFromRepairDetail = props.from === 'service-detail'
  if (isFromRepairDetail) {
    result.height = '36px'
  }
  if (props.showMarginLeft) {
    result.marginLeft = `${isFromRepairDetail ? 12 : 16}px`
  }
  return result
})

async function confirmHandle() {
  try {
    await showConfirmModal({
      title: '定责',
      message: '是否确认定责结果？',
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  try {
    showToastLoading()
    await confirmTechnicalSupport(props.guid)
    removeServiceOrderKeepAlive()
    showToastSuccess('确认成功')
    emits('update')
  } catch (error) {
    commonErrorHandle(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Button), {
      round: "",
      class: "confirm-button xa-vant-button",
      onClick: confirmHandle,
      style: _normalizeStyle(_unref(buttonStyle))
    }, {
      default: _withCtx(() => [
        _createTextVNode("确认定责结果")
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}
}

})